import { pxToRem } from "@/util";
import { Box, Typography } from "@mui/material";
import React from "react";
import Image from "next/image";
import { makeStyles } from "tss-react/mui";
import { AppColors } from "@/assets/colors";

interface Props {
  image: string;
  title: string;
  description: string;
}

export default function Consult({ image, title, description }: Props) {
  const { classes } = styles();
  return (
    <Box className={classes.container}>
      <Box className={classes.consultDisplay}>
        <Image src={image} width={68} height={68} alt={"icon"} />
        <Typography className={classes.consultTitle}>{title}</Typography>
        <Typography className={classes.consultDescription}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: pxToRem(8),
    boxShadow: `${pxToRem(0)} ${pxToRem(4)} ${pxToRem(10)} rgba(0, 0, 0, 0.1)`,
    padding: theme.spacing(3),
    backgroundColor: AppColors.neutral["90"],
    minWidth: pxToRem(300),
    [theme.breakpoints.down("sm")]: {
      width: "75%",
    },
  },
  consultDisplay: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: pxToRem(329),
    width: pxToRem(413.33),
    textAlign: "center",
    gap: theme.spacing(4),
  },
  consultTitle: {
    fontWeight: 600,
    fontSize: pxToRem(20),
    lineHeight: "160%",
    letterSpacing: "0%",
    fontFamily: "General Sans",
    color: AppColors.primary["600"],
  },
  consultDescription: {
    fontWeight: 400,
    fontSize: pxToRem(18),
    color: AppColors.primary["600"],
    width: "80%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: pxToRem(17),
    },
  },
}));
